var axios = require('axios')
const url = process.env.version2 + '/product-menu-fe'
const urlMenu = process.env.version2 + '/product-menu-fe/menu'
const urlCutlery = process.env.version2 + '/product-menu-fe/cutlery'
const urlMenuCombo = process.env.version2 + '/product-menu-fe/menu/'
const urlCategory = process.env.version2 + '/product-menu-fe/category'
const urlHalfFirst = process.env.version2 + '/product-menu-fe/first-layers'
const urlHalfSecond = process.env.version2 + '/product-menu-fe/second-layers'
const urlFriendlyNameSeo = process.env.version2 + '/product-menu-fe/menu-by-nameseo'
const urlPlasticBag = process.env.version2 + '/product-menu-fe/get-item-by-type'

axios.getHalf = function (type, data, success, callBackError) {
  axios.options.flag = false
    var url = urlHalfFirst;
    if (type == 2) {
        url = urlHalfSecond;
    }

    this.get(url, {params: data})
        .then(response => {
            success(response)
        }).catch(error => {
        if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
            if (typeof callBackError !== 'undefined') {
                callBackError(error.response.data)
            }
        }
    })
}

axios.getMenuByCategory = function (data, success, callBackError) {
  axios.options.flag = false
  this.get(urlMenu, {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
      if (typeof callBackError !== 'undefined') {
        let errorTmp = (error.response && error.response.data) ? error.response.data : ''
        callBackError(errorTmp)
      }
    })
}

axios.getAddOnByCategory = function (data, success, callBackError) {
  axios.options.flag = false
  this.get(url + '/add-on?', {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getMenuCombo = function (data, success, callBackError) {
  this.get(urlMenuCombo, {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
axios.getMenuDetails = function (uuid, data, success, callBackError) {
  this.get(urlMenu + '/' + uuid, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getComboDetails = function (uuid, data, success, callBackError) {
  this.get(urlMenuCombo + uuid, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getListCategory = function (data, success, callBackError) {
  axios.defaults.headers.common['Lang'] = data['lang'] || axios.defaults.headers.common['Lang']
  axios.options.flag = false
  let url = urlCategory + '?' + data
  this.get(url, data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getCutlery = function (data, success, callBackError) {
  axios.options.flag = false
  this.get(urlCutlery, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getListHalf = function (data, success, callBackError) {
  axios.options.flag = false
  this.get(urlMenu, {params: data})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getComboDetailsFriendlyNameSeo = function (data, success, callBackError) {
  axios.options.flag = true
  this.get(urlFriendlyNameSeo, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getPlasticBag = function (data, success, callBackError) {
  axios.options.flag = true
  this.get(urlPlasticBag, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/api/Menu.js